import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { DocumentStakeholder } from "../../../@types/documentStakeholder";
import axiosInstance from "../../../utils/axiosConfig";

export const notifySigner = createAsyncThunk(
  "documentShow/notifySigner",
  async (documentStakeholder: DocumentStakeholder, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`${api.baseURL}notification`, {
        assignedTo: documentStakeholder.stakeholder?.id,
        text: `El acuerdo ${documentStakeholder.document?.title} ya está disponible para su firma.`,
        moduleId: documentStakeholder.document.id,
        moduleName: "Document",
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
